module.exports = __webpack_public_path__ + "img/56352F_1E110F_311C19_3C231C-256px.c9bf8775.png";